import { memo } from 'react';
import AssignmentSection from './sections/AssignmentSection.jsx';
import AiInsightsSection from './sections/AiInsightsSection.jsx';
import ChipSelectSection from './sections/ChipSelectSection.jsx';
import TitleSection from './sections/TitleSection.jsx';
import DatePresetsSection from './sections/DatePresetsSection.jsx';
import DateRangeSection from './sections/DateRangeSection.jsx';
import MultiSelectSection from './sections/MultiSelectSection.jsx';
import NumericRangeSection from './sections/NumericRangeSection.jsx';
import PrioritySection from './sections/PrioritySection.jsx';
import SearchSelectSection from './sections/SearchSelectSection.jsx';
import SingleSelectSection from './sections/SingleSelectSection.jsx';
import SortSection from './sections/SortSection.jsx';
import ToggleListSection from './sections/ToggleListSection.jsx';

const SECTION_COMPONENTS = {
  'chip-select': ChipSelectSection,
  'toggle-list': ToggleListSection,
  'multi-select': MultiSelectSection,
  priority: PrioritySection,
  'date-presets': DatePresetsSection,
  'numeric-range': NumericRangeSection,
  'search-select': SearchSelectSection,
  'single-select': SingleSelectSection,
  title: TitleSection,
  sort: SortSection,
  assignment: AssignmentSection,
  'date-range': DateRangeSection,
  'ai-insights': AiInsightsSection,
};

const FilterSlideoutSectionRenderer = ({ section }) => {
  const SectionComponent = SECTION_COMPONENTS[section?.type];
  if (!SectionComponent) return null;
  return <SectionComponent section={section} />;
};

export default memo(FilterSlideoutSectionRenderer);
